import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';

import { config } from './config';
import { store } from './configuration/setup/store';
import { ErrorBoundary } from './components/ErrorBoundary';
import App from './layout/App';
import ErrorFallback from './components/ErrorFallback';
import { ensureUserIsLoggedIn } from './configuration/login/index.';
import { getUserSessionHooks } from './configuration';

const renderApplication = () => {
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
        <ErrorBoundary fallback={<ErrorFallback />}>
            <Provider store={store}>
                <HashRouter>
                    <App />
                </HashRouter>
            </Provider>
        </ErrorBoundary>
    );
};

const isDev = import.meta.env.DEV;
const isProd = import.meta.env.PROD;
const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;

if ((isDev && config.enableMockServer) || isProdPreview) {
    await import('../mocks/serviceMock').then(({ startWorker }) => startWorker());
}

await ensureUserIsLoggedIn(renderApplication, getUserSessionHooks());
